import BreadcrumbWrapper from '@Components/BreadcrumbWrapper';
import ShopOrdersList from '@Components/ShopOrdersList';

export default function Orders() {
  return (
    <div className="flex flex-col gap-4">
      <BreadcrumbWrapper
        crumbArray={[{ path: '/shop/orders', label: 'Orders' }]}
      />
      <h1 className="text-2xl font-bold">Orders</h1>
      <ShopOrdersList />
    </div>
  );
}
